import React from 'react';
import { motion } from 'framer-motion';
export function Founder() {
  const customEase = [0.16, 1, 0.3, 1];
  return <section id="founder" className="py-24 md:py-32 bg-white relative overflow-hidden" data-id="element-200">
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12" data-id="element-201">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center" data-id="element-202">
          {/* Content Left */}
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 1,
          ease: customEase
        }} className="order-2 lg:order-1" data-id="element-203">
            <div className="mb-6" data-id="element-204">
              <span className="text-copper text-xs uppercase tracking-[0.3em] font-semibold" data-id="element-205">
                Meet Your Trainer
              </span>
            </div>

            <h2 className="font-serif text-5xl md:text-6xl font-light text-ink mb-8 leading-tight" data-id="element-206">
              Led by Experience, <br className="hidden md:block" data-id="element-207" />
              <span className="italic" data-id="element-208">Not Just Theory</span>
            </h2>

            <div className="space-y-6 text-stone font-sans text-lg mb-12" data-id="element-209">
              <p data-id="element-210">
                With 360+ training sessions delivered last year alone, your
                trainer brings a rare combination of technical mastery and
                genuine teaching ability. Based on Australia's east coast, he
                works across Brisbane, Sydney, and Melbourne — bringing premium
                makeup education to students of every skill level.
              </p>
              <p data-id="element-211">
                Every masterclass is designed around practical, real-world
                techniques — not trends you'll never use. The focus is always on
                building your confidence, understanding your products, and
                leaving with skills you can apply the very next morning.
              </p>
            </div>

            {/* Stats Row */}
            <div className="flex flex-wrap items-center gap-y-8 mb-12" data-id="element-212">
              <div className="pr-8 border-r border-cream-dark" data-id="element-213">
                <div className="font-serif text-3xl text-copper mb-1" data-id="element-214">360+</div>
                <div className="text-xs uppercase tracking-widest text-stone" data-id="element-215">
                  Sessions Last Year
                </div>
              </div>
              <div className="px-8 border-r border-cream-dark" data-id="element-216">
                <div className="font-serif text-3xl text-ink mb-1" data-id="element-217">3</div>
                <div className="text-xs uppercase tracking-widest text-stone" data-id="element-218">
                  Cities Nationwide
                </div>
              </div>
              <div className="pl-8" data-id="element-219">
                <div className="font-serif text-3xl text-ink mb-1" data-id="element-220">4.9★</div>
                <div className="text-xs uppercase tracking-widest text-stone" data-id="element-221">
                  Average Rating
                </div>
              </div>
            </div>

            <a href="#masterclasses" className="inline-block text-xs uppercase tracking-[0.2em] text-ink hover:text-copper transition-colors border-b border-ink hover:border-copper pb-1" data-id="element-222">
              Book a Masterclass &rarr;
            </a>
          </motion.div>

          {/* Image Right */}
          <motion.div initial={{
          opacity: 0,
          scale: 1.03
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 1.2,
          ease: customEase
        }} className="order-1 lg:order-2 h-[500px] lg:h-[600px] relative overflow-hidden bg-cream-dark" data-id="element-223">
            <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&q=80" alt="Founder Portrait" className="w-full h-full object-cover img-editorial" data-id="element-224" />
            <div className="warm-overlay absolute inset-0" data-id="element-225"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}